import { CLIENT_FIELDS_OF_STUDY } from '@src/graphql/queries/clientFieldOfStudy';
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useClientFieldsOfStudy = ({ clientId, searchText, initialPageSize = 10, }) => {
    const { page, setPage, pageSize, setPageSize, total, items: clientFieldsOfStudy, loading, error, find, orderBy, orderByDir, setOrderBy, setOrderByDir, refetch, } = usePaginatedFetchItems({
        spec: { clientId, name: searchText },
        fetchQuery: CLIENT_FIELDS_OF_STUDY,
        dataProp: 'clientFieldsOfStudy',
        initialPageSize,
    });
    return {
        clientFieldsOfStudy,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        error,
        total,
        find,
        orderBy,
        orderByDir,
        setOrderBy,
        setOrderByDir,
        refetch,
    };
};
